import type { PinV1 } from './PinV1'

export function exportPinsToJson(pins: PinV1[]): string {
  return JSON.stringify(pins, null, 2)
}

export function sanitizeFilename(name: string): string {
  const cleaned = name.replace(/[\\/:*?"<>|]/g, '_').trim()
  return cleaned.length === 0 ? 'collection' : cleaned
}

export function downloadJson(filename: string, content: string) {
  const safeName = sanitizeFilename(filename)
  const blob = new Blob([content], { type: 'application/json' })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = safeName
  a.click()
  // Defer revoke so the browser has time to start the download from the blob URL.
  setTimeout(() => URL.revokeObjectURL(url), 0)
}
